import { render, staticRenderFns } from "./IconRoundedButton.vue?vue&type=template&id=59d538ec&scoped=true"
import script from "./IconRoundedButton.vue?vue&type=script&lang=js"
export * from "./IconRoundedButton.vue?vue&type=script&lang=js"
import style0 from "./IconRoundedButton.vue?vue&type=style&index=0&id=59d538ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d538ec",
  null
  
)

export default component.exports